import {Injectable} from '@angular/core';
import {IInvoiceTemplate} from './template.interface';

@Injectable({providedIn: 'root'})
export class InvoiceAutomationTabService {
  /** Set before opening the tab; null = open without column filter, object = filter by template. */
  pendingTemplate: IInvoiceTemplate | null | undefined = undefined;
}
